module.exports = {"id":"237211","name":"Yuri Ribeiro","rating":"73","photo":"./data/images/photos/3/237211.png","club":{"name":"Rio Ave","logo":"./data/images/clubs/RioAve.png"},"positions":["DG"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/YuriRibeiro0.json
// module id = 4444
// module chunks = 0